import { render } from "./Scroller.vue?vue&type=template&id=1ae13f22&scoped=true"
import script from "./Scroller.vue?vue&type=script&lang=js"
export * from "./Scroller.vue?vue&type=script&lang=js"

import "./Scroller.vue?vue&type=style&index=0&id=1ae13f22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae13f22"]])

export default __exports__